import React from "react";
import "../Pages/CSS/TermsConditions.css";

const TermsConditions = () => {
  return (
    <div className="terms-container">
      <h1>Terms & Conditions</h1>

      <section>
        <h2>Introduction</h2>
        <p>
          Welcome to RunWear Shoes. By accessing or using our website, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
        </p>
      </section>

      <section>
        <h2>Orders</h2>
        <p>
          All orders placed on our website are subject to acceptance and availability. We reserve the right to cancel or refuse any order for any reason.
        </p>
      </section>

      <section>
        <h2>Payment</h2>
        <p>
          Payments must be made through the provided secure payment methods. Currently, we accept Cash on Delivery (COD) and Online Credit/Debit Card Payments.
        </p>
      </section>

      <section>
        <h2>Shipping & Delivery</h2>
        <p>
          Shipping is processed after order confirmation. Delivery timelines are as follows:
        </p>
        <ul>
          <li>Within Pakistan: 7 working days</li>
          <li>International: 14 working days after VAT confirmation</li>
        </ul>
        <p>
          Shipping fees may apply and are displayed during checkout.
        </p>
      </section>

      <section>
        <h2>Returns & Refunds</h2>
        <p>
          You may return items as per our Returns Policy. Once an order is dispatched, changes or cancellations are not possible. Refunds will be processed according to our policy guidelines.
        </p>
      </section>

      <section>
        <h2>Privacy</h2>
        <p>
          Your personal data will be handled according to our Privacy Policy. We respect your privacy and protect your information with secure measures.
        </p>
      </section>

      <section>
        <h2>Use of Website</h2>
        <p>
          You agree not to misuse our website or engage in any activity that could harm, disrupt, or interfere with the website’s functionality or security.
        </p>
      </section>

      <section>
        <h2>Limitation of Liability</h2>
        <p>
          RunWear Shoes will not be liable for any indirect, incidental, or consequential damages arising from the use of our website or purchase of products.
        </p>
      </section>

      <section>
        <h2>Governing Law</h2>
        <p>
          These terms and conditions are governed by the laws of Pakistan. Any disputes arising shall be subject to the jurisdiction of Pakistani courts.
        </p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>
          If you have any questions regarding these terms and conditions, please contact us at:
        </p>
        <p>Email: khanCollection@gmail.com</p>
        <p>Phone: +92 42 111 647 428</p>
        <p>Address: 21 Km Ferozpur Road, Lahore, Pakistan</p>
      </section>
    </div>
  );
};

export default TermsConditions;
